import data from "../../../../data/schema/shared/sharedData";

export default {
  name: "Agent/Attorney (Individual) Profile",
  sections: [
    {
      name: "Type of Representation",
      fields: [
        {
          isGroup: {
            label:
              "Indicate the type of representation for the employer in the filing of this application",
            machine_name: "new_profile_individual_agent_type_id",
            tooltip:
              'Enter whether this application is for "Agent" or for a "Attorney."',
            coloring: "none",
            fields: [
              {
                widget: "radio",
                choice: "Agent",
                value: "Agent",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Attorney",
                value: "Attorney",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Individual Agent/Attorney - Name",
      fields: [
        {
          machine_name: "new_profile_individual_agent_last_name",
          widget: "text",
          label: "Last (given) name",
          validate: ["required"],
          maxLength: 35,
          tooltip: "Enter the last name of the individual agent/attorney.",
        },
        {
          machine_name: "new_profile_individual_agent_first_name",
          widget: "text",
          label: "First (given) name",
          validate: ["required"],
          maxLength: 35,
          tooltip: "Enter the first name of the individual agent/attorney.",
        },
        {
          machine_name: "new_profile_individual_agent_middle_name",
          widget: "text",
          label: "Middle Name(s)",
          maxLength: 35,
          tooltip: "Enter the middle name of the individual agent/attorney.",
        },
      ],
    },
    {
      name: "Individual Agent/Attorney - Address",
      fields: [
        {
          machine_name: "new_profile_individual_agent_address_1",
          widget: "text",
          label: "Address 1",
          validate: ["required"],
          maxLength: 60,
          tooltip:
            "Enter the street address of the agent/attorney’s principal place of business.",
        },
        {
          machine_name: "new_profile_individual_agent_address_2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i></span>",
          maxLength: 60,
          tooltip:
            "If additional space is needed for the street address, use this line to complete the agent/attorney's street address.",
        },
        {
          machine_name: "new_profile_individual_agent_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          clearSchema: ["new_profile_individual_agent_state_id"],
          tooltip:
            "Enter the country of the agent/attorney’s principal place of business.",
        },
        {
          machine_name: "new_profile_individual_agent_state_id",
          widget: "select",
          label: "State",
          selection: data.state,
          validate: ["required"],
          isVisible: {
            when: "new_profile_individual_agent_country_id",
            is: "UNITED STATES OF AMERICA",
          },
          tooltip:
            "Enter the State, District, or Territory of the agent/attorney’s principal place of business.",
        },
        {
          machine_name: "new_profile_individual_agent_city",
          widget: "text",
          label: "City",
          maxLength: 35,
          validate: ["required"],
          tooltip:
            "Enter the city of the agent/attorney’s principal place of business.",
        },
        {
          machine_name: "new_profile_individual_agent_zip",
          widget: "text",
          label: "Postal code",
          maxLength: 10,
          validate: [
            "required",
            {
              postalCountry: "new_profile_individual_agent_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "new_profile_individual_agent_country_id",
              },
            },
          ],
          tooltip:
            "Enter the postal (zip) code of the agent/attorney’s principal place of business.",
        },
        {
          machine_name: "new_profile_individual_agent_province",
          widget: "text",
          label: "Province",
          maxLength: 25,
          tooltip:
            "Enter the province of the agent/attorney’s principal place of business, if applicable.",
        },
      ],
    },
    {
      name: "Individual Agent/Attorney - Contact Information",
      fields: [
        {
          machine_name: "new_profile_individual_agent_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          tooltip:
            "Enter the area code and business telephone number of the agent/attorney’s principal place of business.",
        },
        {
          machine_name: "new_profile_individual_agent_phone_ext",
          widget: "phone_ext",
          label: "Extension",
          maxLength: 4,
          validate: ["number"],
          tooltip:
            "Enter the extension of the telephone number of the agent/attorney’s point of contact, if applicable.",
        },
        {
          machine_name: "new_profile_individual_agent_email",
          widget: "text",
          label: "Business Email Address",
          maxLength: 55,
          validate: [
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          tooltip: "Enter the business email address, if applicable.",
        },
      ],
    },
    {
      name: "Individual Agent/Attorney - Identifier(s)",
      fields: [
        {
          machine_name: "new_profile_individual_agent_bar_number",
          widget: "text",
          label: "State Bar Number(s)",
          maxLength: 35,
          tooltip:
            "Enter the attorney's state bar identification number.  If the attorney is licensed in more than one state, enter only one state bar identification number.  If the attorney is licensed in a state where the bar association does not issue identification numbers, this field can be left blank",
        },
        {
          machine_name: "new_profile_individual_agent_court_state_id",
          widget: "select",
          selection: data.state,
          label:
            "State of highest state court where the attorney is in good standing",
          tooltip:
            "Enter the <u>state</u> of the highest state court where the attorney is in good standing.",
        },
        {
          machine_name: "new_profile_individual_agent_court_name",
          widget: "text",
          maxLength: 55,
          label:
            "Name of the highest state court where attorney is in good standing",
          tooltip:
            "Enter the <u>name</u> of the highest state court where the attorney is in good standing.",
        },
        {
          machine_name: "new_profile_individual_agent_job_title",
          widget: "text",
          label: "Job Title",
          validate: ["required"],
          maxLength: 60,
          tooltip: "Enter the job title of the agent/attorney.",
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_individual_agent_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          validate: ["required"],
          maxLength: 50,
          tooltip:
            "Enter a unique name that will allow you to identify this profile.",
        },
      ],
    },
  ],
};
